export default function formatSearchQueryForText(queryText = "") {
  return "text=" + encodeURIComponent(queryText.trim());
}
